import React from 'react';
import { Link } from 'react-router-dom';
import DropdownDots from './DropdownDots';

const actions = [
  {
    name: 'Compartir por Email',
    icon: 'ion-android-mail c-cyan',
  },
  {
    name: 'Descargar PDF',
    icon: 'ion-arrow-down-a c-cyan',
  },
  {
    name: 'Descargar Excel',
    icon: 'ion-arrow-down-a c-cyan',
  },
];

const PageHeader = props => (
  <div className='pageHead-mainRow-container'>
    <div className='pageHead-mainRow wrapper'>
      <h1 className='pageHead-title'>{props.title}</h1>
      <div className='pageHead-mainRow-actions'>
        {
          props.link &&
            <Link to={props.link} className='pageHead-mainRow-actions'>
              <button className='btn btn-primary'>{props.buttonName}</button>
            </Link>
        }
        {
          props.openModal &&
            <button className='btn btn-primary' onClick={(e) =>  props.openModal(props.modalName)} data-permisos='ind_nueva_ficha_de_venta'>{props.buttonName}</button>
        }
        {/* <DropdownDots actions={actions} /> */}
      </div>
    </div>
  </div>
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js